import { defaultPaddingLeft, defaultPaddingTop, mobileDefaultPadding } from 'constants/sizes';
import Device from 'constants/deviceSizes';

export default {
  container: {
    width: '100%',
    boxSizing: 'border-box',
    padding: `${defaultPaddingTop}px ${defaultPaddingLeft}px 60px`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'justify',
    [Device.mobile]: {
      padding: mobileDefaultPadding
    }
  }
};
